import React from 'react';
import { Box } from '@mui/material';
import { Popup } from 'react-mapbox-gl';

import { formatCoordinate } from '../../../../../utils/formatCoordinates';

const PopUpCard = ({ coordinates, image, name, description }) => {
  return (
    <>
      {coordinates && (
        <Popup
          coordinates={formatCoordinate(coordinates)}
          style={{
            padding: '24px',
            width: '200px',
          }}
        >
          <img
            src={image}
            alt="Popup Image"
            style={{
              aspectRatio: '200/150',
              objectFit: 'cover',
              width: '100%',
            }}
          />

          <Box>
            <Box
              as="h5"
              sx={{
                fontSize: '1rem',
                marginTop: '0.5rem',
                marginBottom: '0',
              }}
            >
              {name}
            </Box>
            <p
              style={{
                fontSize: '0.875rem',
              }}
            >
              {description}
            </p>
          </Box>
        </Popup>
      )}
    </>
  );
};

export default PopUpCard;
